import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Button } from '@mui/material';
import { TextInput } from '../../../components/muiCustomized/TextInput';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { NotificationContext } from '../../../contexts/Notification';

function EditDesignationModal({
  designation,
  isEditing,
  closeModal,
  onDesignationSaved,
  workspaceId,
}) {
  const { displayNotification } = useContext(NotificationContext);
  const [isSaving, setIsSaving] = useState(false);
  const [name, setName] = useState(designation?.name ?? '');
  const [formErrors, setFormErrors] = useState({});

  const handleSaveDesignation = async () => {
    setIsSaving(true);
    const { data, success } = await sendRequest({
      method: 'post',
      url: API.WORKSPACE.designation(workspaceId),
      data: {
        name,
        id: designation?.id ?? null,
      },
    });
    if (success) {
      onDesignationSaved();
      closeModal();
      displayNotification({
        message: 'Designation saved successfully.',
        severity: 'success',
      });
    } else {
      setFormErrors(data);
      displayNotification({
        message: 'Error occurs while saving designation.',
        severity: 'error',
      });
    }
    setIsSaving(false);
  };

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c create-team-modal">
      <Box style={{
        width: 489,
        padding: 32,
        background: '#fff',
        borderRadius: 8,
      }}
      >
        <div className="modal-header">
          <h5 className="m-b16 text-600">
            {isEditing ? 'Edit ' : 'Add '}
            {' '}
            Designation
          </h5>
        </div>
        <div className="modal-body p-0">
          <div className="input-wrapper">
            <TextInput
              label="Designation Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Required"
              error={!!formErrors?.name}
              helperText={formErrors?.name}
            />
          </div>
        </div>

        <div className="modal-footer border-0 p-0 mt-2">
          <Button
            sx={{
              marginRight: 2,
              textTransform: 'none',
              fontSize: '16px',
              height: '40px',
              padding: '12px 16px 12px 16px',
            }}
            variant="outlined"
            onClick={closeModal}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: 'none',
              fontSize: '16px',
              height: '40px',
              padding: '12px 16px 12px 16px',
            }}
            variant="contained"
            onClick={handleSaveDesignation}
            disabled={isSaving || !name || (designation ? designation.name === name : false)}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {isSaving ? 'Saving...' : isEditing ? 'Save Changes' : 'Save Designation'}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

EditDesignationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onDesignationSaved: PropTypes.func.isRequired,
  designation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    workspaceId: PropTypes.number.isRequired,
  }),
  isEditing: PropTypes.bool.isRequired,
  workspaceId: PropTypes.number.isRequired,
};

export default EditDesignationModal;
